<template>
	<div class="cover-container shadow">
		<div class="w-100 h-100">
			<image-loader :src="getImageSource(meal.img)" class="cover-image" />
		</div>
		<div class="cover-overlay">
			<div class="badges" v-if="meal.cook_type && meal.meal_type">
				<span class="badge me-2" :class="[getCookTypeColor(meal.cook_type)]">{{
					meal.cook_type
				}}</span
				><span class="badge" :class="[getMealTypeColor(meal.meal_type)]">{{
					meal.meal_type
				}}</span>
			</div>
			<div v-if="meal.restaurant_name" class="location">
				<div class="d-flex align-items-center">
					<i class="bi bi-geo-alt-fill me-2"></i>
					<span>{{ meal.restaurant_name }}</span>
				</div>
			</div>
			<div class="text-center pt-4">
				<h5>{{ getName(meal) }}</h5>
				<p>
					{{ getDescription(meal) }}
				</p>
			</div>
			<allergy :meal="meal" />
			<div class="rating-container">
				<rating-gauge
					class="rating-gauge"
					width="80"
					:rating="meal.rating"
					v-if="meal.rating" />
			</div>
		</div>
	</div>
</template>

<script setup>
	import RatingGauge from "./RatingGauge.vue"
	import {
		getImageSource,
		getName,
		getCookTypeColor,
		getMealTypeColor,
		getDescription,
	} from "../utils/mealLib"
	import ImageLoader from "./ImageLoader.vue"
	import Allergy from "./Allergy.vue"

	const props = defineProps({ meal: Object })
</script>

<style lang="less" scoped>
	.cover-container {
		cursor: pointer;
		position: relative;
		height: 350px; // Adjust max-height as needed
		// max-width: 300px;
		width: 350px;
		// overflow: hidden;
		margin-bottom: @spacing; // Use a variable for spacing or replace with a value
		overflow: hidden;

		.cover-image {
			height: 100%;
			::v-deep(> img) {
				max-height: 350px;
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center; // This centers the image in the container
			}
		}

		.cover-overlay {
			position: absolute;
			top: 0;
			// start: 0;
			width: 100%;
			height: 100%;
			background: rgba(
				0,
				0,
				0,
				0.6
			); // Semi-transparent overlay for text readability
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;

			.location {
				position: absolute;
				top: 35px;
				right: 20px;
				background: rgba(0, 0, 0, 0.2);
			}

			.badges {
				position: absolute;
				top: 10px;
				right: 20px;
			}

			p {
				text-align: center;
				padding: @padding; // Use a variable for padding or replace with a value
				padding-top: 0;
				z-index: 2;
				color: @text-color-white; // Use a variable for text color or replace with a value
			}

			.allergy-container {
				position: absolute;
				bottom: 10px;
				left: 10px;
			}

			.rating-container {
				// background: rgba(0, 0, 0, 0.3);
				position: absolute;
				bottom: 10px;
				right: 10px;
				cursor: pointer;
			}
		}
	}

	// Variables (if not defined, replace with actual values)
	@spacing: 1rem;
	@padding: 1rem;
	@text-color-white: #fff;
</style>
